// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"23830df9","422":"44d68ca7","690":"8ee1569e"}[chunkId] + ".chunk.js";
};